import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/tamdaone/tamdamedia/src/app/[locale]/(root)/letak/[id]/LeafletDetailView.tsx");
